export const hotSpotsList = [
  'role_all',
  'organisations',
  'user_all',
  'container_type',
  'garbage_type',
  'platform_type',
  'failure_reason',
  'early completion',
  'breakdown_type',
  'weight_cancel_reason',
  'list_sensor_containers',
  'reasons_stopped_container',
  'reasons_for_the_application',
  'navigation_systems',
  'divisions_organisation',
  'reason_for_transferring_kp',
  'inventory',
  'inventory_platform',
  'online_monitoring',
  'online_monitoring_photo',
  'online_monitoring_photo_beta',
  'vehicle',
  'polygon',
  'online_list',
  'monitoring_vehicle',
  'Integration',
  'Integrations',
  'Integration_element_technology',
  'vehicle_sensor',
  'all_list_sensor_components',
  'install_documents',
  'instruction_documents',
  'fichas_update',
  'task_installer',
  'command_gserver',
  'list_logs',
  'organisation_settings',
  'localities_area',
  'municipal_association',
  'inventory_inspectors',
  'inspector_task',
  'incpectors_district',
  'sub_category',
  'notification-templates',
  'drivers',
  'report-transporter-value',
  'employee',
  'labels',
  'fgis-logs',
  'link_to_fgis',
  'manager-mobile-version',
];

export const stateMenuList = [
  {
    routeName: 'directories-menu',
    titleMenu: 'Cправочники',
    value: 'Cправочники',
    label: 'Cправочники',
  },
  {
    routeName: 'inventory-menu',
    titleMenu: 'Инвентаризация',
    value: 'Инвентаризация',
    label: 'Инвентаризация',
  },
  {
    routeName: 'fact-menu',
    titleMenu: 'Факт',
    value: 'Факт',
    label: 'Факт',
  },
  {
    routeName: 'logistic-menu',
    titleMenu: 'Логистика',
    value: 'Логистика',
    label: 'Логистика',
  },
  {
    routeName: 'reports-menu',
    titleMenu: 'Отчёты',
    value: 'Отчёты',
    label: 'Отчёты',
  },
  {
    routeName: 'installer-menu',
    titleMenu: 'Установщик',
    value: 'Установщик',
    label: 'Установщик',
  },
  {
    routeName: 'report-on-sz',
    titleMenu: 'Отчёт по СЗ',
    value: 'Отчёт по СЗ',
    label: 'Отчёт по СЗ',
  },
  {
    routeName: 'notifications',
    titleMenu: 'Уведомления',
    value: 'Уведомления',
    label: 'Уведомления',
  },
  {
    routeName: 'recipients',
    titleMenu: 'Адресаты',
    value: 'Адресаты',
    label: 'Адресаты',
  },
  {
    routeName: 'contract-block',
    titleMenu: 'Договорной блок',
    value: 'Договорной блок',
    label: 'Договорной блок',
  },
  {
    routeName: 'contract-block-services',
    titleMenu: 'Список услуг',
    value: 'Список услуг',
    label: 'Список услуг',
  },
  {
    routeName: 'contract-block-list-counterparties',
    titleMenu: 'Список контрагентов',
    value: 'Список контрагентов',
    label: 'Список контрагентов',
  },
  {
    routeName: 'contract-block-list-contracts',
    titleMenu: 'Список договоров',
    value: 'Список договоров',
    label: 'Список договоров',
  },
  {
    routeName: 'contract-block-waste-generator-categories',
    titleMenu: 'Категории отходообразователей',
    value: 'Категории отходообразователей',
    label: 'Категории отходообразователей',
  },
  {
    routeName: 'contract-block-templates',
    titleMenu: 'Шаблоны договоров',
    value: 'Шаблоны договоров',
    label: 'Шаблоны договоров',
  },
  {
    routeName: 'contract-block-list-objects',
    titleMenu: 'Список объектов',
    value: 'Список объектов',
    label: 'Список объектов',
  },
  {
    routeName: 'report-transporter-value',
    titleMenu: 'Отчёт оценка перевозчика',
    value: 'Отчёт оценка перевозчика',
    label: 'Отчёт оценка перевозчика',
  },
  {
    routeName: 'report_delay',
    titleMenu: 'Отчёт по опозданиям',
    value: 'Отчёт по опозданиям',
    label: 'Отчёт по опозданиям',
  },
  {
    routeName: 'report-work-drivers',
    titleMenu: 'Отчёт по работе водителей',
    value: 'Отчёт по работе водителей',
    label: 'Отчёт по работе водителей',
  },
  {
    routeName: 'non-export-act',
    titleMenu: 'Отчёт акт по невывозам',
    value: 'Отчёт акт по невывозам',
    label: 'Отчёт акт по невывозам',
  },
  {
    routeName: 'districts',
    titleMenu: 'Районы',
    value: 'Районы',
    label: 'Районы',
  },
  {
    routeName: 'talon-event-log',
    titleMenu: 'Журнал событий',
    value: 'Журнал событий',
    label: 'Журнал событий',
  },
  {
    routeName: 'talon-roles-access',
    titleMenu: 'Роли и доступы',
    value: 'Роли и доступы',
    label: 'Роли и доступы',
  },
  {
    routeName: 'talon-contractors',
    titleMenu: 'Контрагенты',
    value: 'Контрагенты',
    label: 'Контрагенты',
  },
  {
    routeName: 'talon-vehicles',
    titleMenu: 'Транспортные средства',
    value: 'Транспортные средства',
    label: 'Транспортные средства',
  },
  {
    routeName: 'reference-notifications',
    titleMenu: 'Уведомления',
    value: 'Уведомления',
    label: 'Уведомления',
  },
  {
    routeName: 'talon-integration-settings',
    titleMenu: 'Настройки интеграции',
    value: 'Настройки интеграции',
    label: 'Настройки интеграции',
  },
  {
    routeName: 'talon-ticket-log',
    titleMenu: 'Журнал талонов',
    value: 'Журнал талонов',
    label: 'Журнал талонов',
  },
  {
    routeName: 'talon-weighing-log',
    titleMenu: 'Журнал взвешиваний',
    value: 'Журнал взвешиваний',
    label: 'Журнал взвешиваний',
  },
  {
    routeName: 'talon-period-reports',
    titleMenu: 'Отчеты по периодам',
    value: 'Отчеты по периодам',
    label: 'Отчеты по периодам',
  },
  {
    routeName: 'talon-contractor-reconciliation',
    titleMenu: 'Сверка с контрагентами',
    value: 'Сверка с контрагентами',
    label: 'Сверка с контрагентами',
  },
  {
    routeName: 'talon-export-1c',
    titleMenu: 'Экспорт в 1С',
    value: 'Экспорт в 1С',
    label: 'Экспорт в 1С',
  },
  {
    routeName: 'talons',
    titleMenu: 'Талоны',
    value: 'Талоны',
    label: 'Талоны',
  },
  {
    routeName: 'contract-journal-ecoprom',
    titleMenu: 'Журнал договоров',
    value: 'Журнал договоров',
    label: 'Журнал договоров',
  },
  {
    routeName: 'registration-journal',
    titleMenu: 'Журнал регистрации',
    value: 'Журнал регистрации',
    label: 'Журнал регистрации',
  },
  {
    routeName: 'detail_calls',
    titleMenu: 'Отчёт детализации звонков',
    value: 'Отчёт детализации звонков',
    label: 'Отчёт детализации звонков',
  },
  {
    routeName: 'report-garbage-truck-occupancy',
    titleMenu: 'Отчёт по заполненности мусоровозов',
    value: 'Отчёт по заполненности мусоровозов',
    label: 'Отчёт по заполненности мусоровозов',
  },
  {
    routeName: 'online_monitoring_new',
    titleMenu: 'Онлайн мониторинг',
    value: 'Онлайн мониторинг',
    label: 'Онлайн мониторинг',
  },
];

